module.exports = __webpack_public_path__ + "static/media/IMG_5348-min.27919dd3.jpg";